import React, { ReactElement } from 'react';
import { useField, useFormikContext, FieldHookConfig } from 'formik';
import type { RadioChangeEvent } from 'antd';
import { Radio, RadioGroupProps } from 'antd';

export type AntdRadioGroupFieldProps = {
  ref?: React.Ref<HTMLDivElement>;
} & FieldHookConfig<string> &
  RadioGroupProps;

export const AntdRadioGroupField = ({
  disabled = false,
  onChange = () => {},
  ...props
}: AntdRadioGroupFieldProps): ReactElement => {
  const [field, , helpers] = useField(props);
  const { isSubmitting } = useFormikContext();

  const handleChange = (event: RadioChangeEvent) => {
    helpers.setValue(event.target.value);
    onChange(event.target.value);
  };

  return (
    <Radio.Group
      {...field}
      disabled={isSubmitting || disabled}
      onChange={handleChange}
      {...props}
    />
  );
};
